export default __webpack_public_path__ + "static/media/thumsUp.cbdf1a1b.svg";